import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLanguage } from '@fortawesome/pro-solid-svg-icons/faLanguage';

import React, { useCallback } from 'react';
import { Button } from 'ui-components/components/button';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import LanguageSelectionModal from '../../components/modals/language-selection-modal';
import { useLocale } from '../../intl/hooks';
import { LocaleCodeToFriendlyNameMap } from '../../intl/locale-context-provider/locale-codes';
import style from './styles.less';

const LocalePicker = () => {
  const [languageSelectionModalOpen, setLanguageSelectionModalOpen] = useAsyncSafeState(false);

  const openLanguageSelectionModal = useCallback(() => {
    setLanguageSelectionModalOpen(true);
  }, [setLanguageSelectionModalOpen]);

  const closeLanguageSelectionModal = useCallback(() => {
    setLanguageSelectionModalOpen(false);
  }, [setLanguageSelectionModalOpen]);

  const { locale: localeToUse } = useLocale();
  const currentLanguageName = LocaleCodeToFriendlyNameMap[localeToUse];

  // To enable language selection, remove display: none style for languages button
  return (
    <>
      <Button className={style['language-button']} onClick={openLanguageSelectionModal} theme='link'>
        <FontAwesomeIcon className={style['languages-icon']} icon={faLanguage} />
        {currentLanguageName}
      </Button>
      {languageSelectionModalOpen && <LanguageSelectionModal onClose={closeLanguageSelectionModal} />}
    </>
  );
};

export default LocalePicker;
